<div class="flex items-center justify-center dialog-header ">
    Add Admission
    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content">
    <div class="p-4">
        <form #admissionForm="ngForm" (ngSubmit)="onSubmit(admissionForm.form.valid)">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div class="col-span-1">
                    <label class="block mb-2">Prefix</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['prefix']" name="prefix"
                        [options]="prefixOptions"></p-select>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">First Name</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;" #first_name="ngModel"
                        pattern="^[a-zA-Z0-9 ]*$" [(ngModel)]="createFieldFormValue['first_name']" name="first_name"
                        required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['first_name']}" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['first_name']">Enter First
                        Name</small>
                    <small class="text-red-500" *ngIf="first_name?.errors?.['pattern']">
                        Special characters are not allowed.
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Last Name</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['last_name']" name="last_name" required #last_name="ngModel"
                        pattern="^[a-zA-Z0-9 ]*$"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['last_name'] }" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['last_name']">Enter Last
                        Name</small>
                    <small class="text-red-500" *ngIf="last_name?.errors?.['pattern']">
                        Special characters are not allowed.
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Contact Email</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['email']" name="email" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['email']}" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['email']">Enter Contact
                        Email</small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Phone Number</label>
                    <input pInputText type="number" class="w-full" style="box-shadow: none !important;"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['phone'] }"
                        [(ngModel)]="createFieldFormValue['phone']" name="phone" required />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['phone']">Enter Contact
                        Number</small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Alternate Number</label>
                    <input pInputText type="number" class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['alternate_phone']" name="alternate_phone" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Date of Birth</label>
                    <p-calendar class="w-full" appendTo="body" [inputStyle]="{
                        'box-shadow':'none !important',
                        'width': '100%'
                    }" [style]="{'box-shadow':'none !important',
                        'width': '100%'
                     }" [maxDate]="today" [(ngModel)]="createFieldFormValue['date_of_birth']" name="date_of_birth">
                    </p-calendar>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Age</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['age']" name="age" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Gender</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['gender']" name="gender"
                        [options]="genderOptions">
                    </p-select>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Blood Group</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['blood_group']" name="blood_group"
                        [options]="bloodGroupOptions">
                    </p-select>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Nationality</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['nationality']" name="nationality" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">City</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['city']" name="city" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">State</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['state']" name="state" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Country</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['country']" name="country" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Postal Code</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['postal_code']" name="postal_code" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Guardian Name</label>
                    <input pInputText class="w-full shadow-none"
                        [(ngModel)]="createFieldFormValue['guardian_name']" name="guardian_name" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Guardian Contact</label>
                    <input pInputText class="w-full shadow-none"
                        [(ngModel)]="createFieldFormValue['guardian_contact']" name="guardian_contact"
                        type="number" placeholder="Enter Guardian Phone Number" />
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Previous Education</label>
                    <input pInputText class="w-full shadow-none"
                        [(ngModel)]="createFieldFormValue['previous_education']" name="previous_education" />
                </div>
            </div>

            <div class="grid grid-cols-1 mt-4">
                <div class="col-span-1">
                    <label class="block mb-2">Address</label>
                    <textarea pTextarea class="w-full" rows="5" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['address']" name="address"></textarea>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
              

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Academic Year</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['academic_year_id']" name="academic_year_id"
                        [options]="academicYears" required
                        optionLabel="year_name" optionValue="id"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['academic_year_id']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['academic_year_id']">
                        Select Academic Year
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Session</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['session']" name="session"
                        [options]="sessionOptions" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['session']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['session']">
                        Select Session
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Course</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['course_id']" name="course_id"
                        [options]="courses" required
                        optionLabel="name" optionValue="course_id"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['course_id']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['course_id']">
                        Select Course
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Department</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['department_id']" name="department_id"
                        [options]="departments" required
                        optionLabel="name" optionValue="dept_id"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['department_id']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['department_id']">
                        Select Department
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Batch</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['batch_id']" name="batch_id"
                        [options]="batches" required
                        optionLabel="batch_name" optionValue="id"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['batch_id']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['batch_id']">
                        Select Batch
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Admission Status</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['admission_status']" name="admission_status"
                        [options]="admissionStatusOptions" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['admission_status']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['admission_status']">
                        Select Admission Status
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Admission Type</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['admission_type']" name="admission_type"
                        [options]="admissionTypeOptions" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['admission_type']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['admission_type']">
                        Select Admission Type
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Category</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['category']" name="category"
                        [options]="categoryOptions">
                    </p-select>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Fee Group</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        optionLabel="group_name" optionValue="id"
                        [(ngModel)]="createFieldFormValue['fee_group_id']" name="fee_group_id"
                        [options]="feeGroups">
                    </p-select>
                </div>

               
                <div class="col-span-1" >
                    <label class="block mb-2">Hostel Category</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        optionLabel="hostel_name" optionValue="id"
                        [(ngModel)]="createFieldFormValue['hostel_category']" name="hostel_category"
                        [options]="hostelCategories">
                    </p-select>
                </div>

               

                <div class="col-span-1" >
                    <label class="block mb-2">Transport Category</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        optionLabel="route_name" optionValue="id"
                        [(ngModel)]="createFieldFormValue['transport_category']" name="transport_category"
                        [options]="transportCategories">
                    </p-select>
                </div>


                <div class="col-span-1" >
                    <label class="block mb-2">Scholarship Category</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        optionLabel="name" optionValue="scholarship_id"
                        [(ngModel)]="createFieldFormValue['scholarship_category']" name="scholarship_category"
                        [options]="scholarshipTypes">
                    </p-select>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Admission Mode</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['admission_mode']" name="admission_mode"
                        [options]="admissionModeOptions" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['admission_mode']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['admission_mode']">
                        Select Admission Mode
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2 requiredValue">Admission Source</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['admission_source']" name="admission_source"
                        [options]="admissionSourceOptions" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['admission_source']}">
                    </p-select>
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['admission_source']">
                        Select Admission Source
                    </small>
                </div>

                <div class="col-span-1">
                    <label class="block mb-2">Assigned To</label>
                    <p-select class="w-full shadow-none" appendTo="body"
                        [(ngModel)]="createFieldFormValue['assigned_to']" name="assigned_to"
                        [options]="users">
                    </p-select>
                </div>
            </div>

            <div class="grid grid-cols-1 mt-4">
                <div class="col-span-1">
                    <label class="block mb-2">Remarks</label>
                    <textarea pTextarea class="w-full" rows="5" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['remarks']" name="remarks"></textarea>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">

                <div class="" *ngFor="let item of allLeadFeilds">
                    <div class="col-span-1 w-full">
                        <label class="block mb-2" [ngClass]="{ 'requiredValue': item.required }">{{ item.label
                            }}</label>
                        <input pInputText *ngIf="item.type !== 'select' && item.type !== 'textarea'" class="w-full"
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            style="box-shadow: none !important;" [required]="item.required === true ? true : false "
                            [ngModelOptions]="{ standalone: false }" placeholder="{{ item.placeholder }}" [ngClass]="{
                    'ng-invalid ng-dirty' : isSubmitted && item.required && !fieldValues[item.field_name]
                }" />
                        <textarea pTextarea *ngIf="item.type === 'textarea'" style="box-shadow: none !important;"
                            class="w-full" [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [ngModelOptions]="{ standalone: false }" [required]="item.required === true ? true : false "
                            placeholder="{{ item.placeholder }}"></textarea>
                        <p-select *ngIf="item.type === 'select'" class="w-full" appendTo="body"
                            [ngModelOptions]="{ standalone: false }" [required]="item.required === true ? true : false "
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [options]="item.data" [placeholder]="item.placeholder"></p-select>
                        <small class="text-red-500"
                            *ngIf="isSubmitted && item.required && !fieldValues[item.field_name]">Enter {{ item.label
                            }}</small>
                    </div>
                </div>

            </div>

            <div class="mt-4">
                <p-button [label]="formAction === 'Add' ? 'Save' : 'Update'"
                    [icon]="formAction === 'Add' ? 'pi pi-save' : 'pi pi-pencil'" [disabled]="isLoading"
                    [loading]="isLoading" type="submit" class="p-button-primary w-full md:w-auto"></p-button>
            </div>
        </form>
    </div>
</div>
